import { createContext, useContext, useState, useCallback } from 'react';
import { LtToastContainer, LtToast } from 'limetray-ui-kit';

const ToastContext = createContext(null);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback(({ title, description, variant = 'success', autoClose }) => {
    const id = Date.now() + Math.random();
    const resolvedAutoClose = autoClose !== undefined ? autoClose : (variant === 'success' ? 5000 : 8000);
    setToasts((prev) => [...prev, { id, title, description, variant, autoClose: resolvedAutoClose }]);
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {toasts.length > 0 && (
        <LtToastContainer position="bottom-right">
          {toasts.map((t) => (
            <LtToast
              key={t.id}
              title={t.title}
              description={t.description}
              variant={t.variant}
              autoClose={t.autoClose}
              onClose={() => removeToast(t.id)}
            />
          ))}
        </LtToastContainer>
      )}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider');
  }
  return context;
};

export default ToastContext;
